import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useSearchableMenu } from './SearchableMenuContext';
export function SearchableMenuSearchHeader(props) {
    const { placeholder } = props;
    const { handleSearch, searchString, loading, resetSearch } = useSearchableMenu();
    const placeholderText = placeholder || t({ message: 'Search', comment: 'Searchable menu search input placeholder' });
    return (<Menu.HeaderSearch placeholder={placeholderText} value={searchString} loading={loading} onChange={handleSearch} onClear={resetSearch}/>);
}
